import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Stack, Switch } from '@mui/material';

type ViewVisibilitySwitchWithHintProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  inputProps: React.ComponentProps<typeof Switch>['inputProps'];
  showSavedHint: boolean;
};

/** מתג + וי ירוק קצר אחרי שמירה מוצלחת (כמו חיווי בשדות בהגדרות) */
const ViewVisibilitySwitchWithHint: React.FC<ViewVisibilitySwitchWithHintProps> = ({
  checked,
  onChange,
  inputProps,
  showSavedHint,
}) => (
  <Stack direction="row" alignItems="center" spacing={0.75} component="span">
    {showSavedHint && (
      <CheckCircleOutlineIcon sx={{ color: 'success.main', fontSize: 22 }} aria-hidden />
    )}
    <Switch edge="end" checked={checked} onChange={(_, v) => onChange(v)} inputProps={inputProps} />
  </Stack>
);

export default ViewVisibilitySwitchWithHint;
